import { decode, encode, PROTOCOL_VERSION } from "./protocol";
import type { Transport } from "./transport/transport";

/**
 * Знакомство сторон: версия протокола, хеш содержимого и сборки, сид матча (его даёт создатель комнаты).
 * Разные версии — понятная ошибка до боя, а не рассинхрон посреди боя (docs/design/abilities.md).
 */
export function handshake(
  transport: Transport,
  role: "host" | "guest",
  content: number,
  proposedSeed: number,
  timeoutMs = 10_000,
): Promise<number> {
  return new Promise((resolve, reject) => {
    let done = false;
    const say = (seed: number): void => {
      transport.send(encode({ type: "hello", version: PROTOCOL_VERSION, content, seed }));
    };
    const timer = setTimeout(() => {
      if (!done) reject(new Error("Соперник не ответил на знакомство"));
    }, timeoutMs);
    const repeat = setInterval(() => {
      if (!done && role === "host") say(proposedSeed);
    }, 300);
    transport.onMessage((bytes) => {
      const message = decode(bytes);
      if (done || message?.type !== "hello") return;
      done = true;
      clearTimeout(timer);
      clearInterval(repeat);
      if (message.version !== PROTOCOL_VERSION || message.content !== content) {
        reject(new Error("У соперника другая версия игры — обновите страницу у обоих"));
        return;
      }
      if (role === "guest") {
        // канал без гарантий: ответ повторяем, чтобы создатель комнаты точно его получил
        let left = 10;
        const echo = setInterval(() => {
          say(message.seed);
          if (--left <= 0) clearInterval(echo);
        }, 100);
        say(message.seed);
      }
      resolve(role === "host" ? proposedSeed : message.seed);
    });
    if (role === "host") say(proposedSeed);
  });
}
